export default "__VITE_ASSET__DTg1Wy5Y__"